import { normalizeControllerEntity } from '../TableControllers';

import { FormAggregationRow, FormAggregationRowApi } from './entity';

export const normalizeFormAggregationRow = (
  raw: FormAggregationRowApi
): FormAggregationRow => ({
  id: raw.id,
  title: raw.title,
  ...normalizeControllerEntity(raw),
});
